import React, { useState, useRef } from 'react';
import ReportIcon from '@material-ui/icons/Report';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Button from '@material-ui/core/Button';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Tooltip from '@material-ui/core/Tooltip';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { IconButton } from '@material-ui/core';
import { CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";
import snapfix_icon from '../images/snapfix_icon.png';
import moment from 'moment';
import TasksTable from './TasksTable';
import UserCard from './UserCard';
import OptionalPage from './OptionalPage';
import AdminCredentials from './Credentials';
import not_found from '../images/not-found.png';
import externalSnapboardRequest from '../Services/externalSnapboard';
import saveImage from '../Services/saveImage';
 import SnapboardLinkPage from './SnapboardLinkPage';
import { makeStyles } from '@material-ui/core/styles';

import './new-user-snapboard.css';

const useStyles = makeStyles((theme) => ({
    title: {
      fontSize: '18px',
    },
  }));

const NewUserSnapboard = () => {
    const classes = useStyles();

    const snapboardImageValue = useRef(null);
    const snapboardLogoValue = useRef(null)
    const [secondPage, setSecondPage] = useState(false);
    const [snapTitle, setSnapTitle] = useState('');
    const [userName,setUserName] = useState('');
    const [jobTitle, setJobTitle] = useState('');
    const [userEmail,setUserEmail] = useState('');
    const [password,setPassword] = useState('');
    const [message1,setMessage1] = useState("Your comfort and safety are our priority");
    const [message2,setMessage2] = useState("We want to make your stay as relaxing as possible");
    const [secondTitle,setSecondTitle] = useState('');
    const [inProgress, setInProgress] = useState(false);
    const [externalURL,setExternalURL] = useState('');
    const [loading, setLoading] = useState(false);
    const [businessLogo,setBusinessLogo] = useState('');
    const [userImage,setUserImage] = useState('');
    const [optionalLogo,setOptionalLogo] = useState('');
    const [optionalImage,setOptionalImage] = useState('');

    const requestData = {
        "wallboard_name": snapTitle,
        "rep_name": userName,
        "rep_title": jobTitle,
        "email": userEmail,
        "password": password,
        "hotel_message01": message1,
        "hotel_message02": message2,
        "hotel_logo_url": businessLogo,
        "rep_image_url": userImage,
        "p2_transition_time": secondPage ? "20" : null,
        "p2_name": secondPage ? secondTitle : null,  
        "p2_logo_url": secondPage ? optionalLogo : null, 
        "p2_image_body_url": secondPage ? optionalImage : null
    };

    const saveExternalSnapboard = async() => {
        if(!snapTitle || !userName || !jobTitle || !message1 || !message2){
            toast.warn("Please, fill in all the fields");
            return;
        };

        if(!userEmail || !password){
            toast.warn("Please, fill the admin credential fields");
            return;
        };

        if(!businessLogo){
            toast.warn("Please, upload a snapboard logo");
            return;
        };

        if(!userImage){
            toast.warn("Please, upload the user image");
            return;
        };

        if(secondPage && !optionalImage) {
            toast.warn("Please, upload the second screen image");
            return;
        };
        setLoading(true)
        await externalSnapboardRequest(requestData)
        .then(res => {
            if(res.result){
                setExternalURL(res.url);
                setLoading(false)
            }else {
                toast.error(res);
                setLoading(false)
            }
        })
    };

    const uploadSnapboardImage = async (uploadedFile) => {
        if(!uploadedFile){
            return
        };
        setInProgress(true);
        await saveImage(uploadedFile)
            .then(res => {
                if (res.image_url) {
                    setBusinessLogo(res.image_url);
                    setInProgress(false)
                } else {
                    toast.error('Something went wrong');
                    setInProgress(false)
                }
            })
    };

    if(!externalURL){
        return (
            <div className="new-user-snapboard">
                <div className="main-heading">
                   <div className="heading-titles">
                        <h1 className="title">CREATE A CUSTOM <span> SNAPBOARD </span> FOR YOUR BUSINESS</h1>
                        <h3 className="subtitle">Fill in the fields below to get your custom link which you can use to display the Snapboard in your building.</h3>
                   </div>
                    <img src={snapfix_icon} alt="snapfix"/>
                </div>
                <div className="snapboard-header-part">
                    <div className="h4">
                        <h4 className="required">
                            SNAPBOARD TITLE
                        </h4>
                        <Tooltip title="Here you can select a title for the Snapboard." classes={{ tooltip: classes.title }}>
                            <ReportIcon style={{ color: '#0d7cf5' }} />
                        </Tooltip>
                        
                    </div>
                    <TextField
                        placeholder="Please enter a title here"
                        id="outlined-basic-field"
                        variant="outlined"
                        size="small"
                        className="title-field"
                        value={snapTitle}
                        onChange={(e) => setSnapTitle(e.currentTarget.value)}
                    />
                </div>
    
                <div className="business-logo-container">
                        <Tooltip title="Here you can select a logo for the Snapboard." classes={{ tooltip: classes.title }}>
                            <ReportIcon style={{ color: '#0d7cf5' }} />
                        </Tooltip>
                    {!inProgress ?
                        <div 
                            className="div-img"
                            style={{ backgroundImage: `url(${!businessLogo ? not_found : businessLogo})`}} 
                        /> :
                        <CircularProgress />
                    }
                               
                    <input
                        accept="image/*"
                        style={{ display: 'none', width: 0, height: 0 }}
                        id="snapboard-logo-image"
                        type="file"
                        onChange={() => uploadSnapboardImage(snapboardImageValue.current.files[0])}
                        ref={snapboardImageValue}
                    />
    
                    <label htmlFor="snapboard-logo-image">
                        <IconButton aria-label="upload picture" component="span">
                            <EditOutlinedIcon />
                        </IconButton>
                    </label>
    
                </div>
    
                <div className="main-snapboard">
                    <div className="business-logo-container-2">
                            <Tooltip title="Here you can select a logo for the Snapboard." classes={{ tooltip: classes.title }}>
                                <ReportIcon style={{ color: '#0d7cf5' }} />
                            </Tooltip>
                        {!inProgress ?
                            <div 
                                className="div-img"
                                style={{ backgroundImage: `url(${!businessLogo ? not_found : businessLogo})`}} 
                            /> :
                            <CircularProgress />
                        }
                                
                        <input
                            accept="image/*"
                            style={{ display: 'none', width: 0, height: 0 }}
                            id="upload-snapboard-logo-image"
                            type="file"
                            onChange={() => uploadSnapboardImage(snapboardLogoValue.current.files[0])}
                            ref={snapboardLogoValue}
                        />
        
                        <label htmlFor="upload-snapboard-logo-image">
                            <IconButton aria-label="upload picture" component="span">
                                <EditOutlinedIcon />
                            </IconButton>
                        </label>
        
                    </div>
                    <TasksTable />
                    <UserCard 
                        name={{userName,setUserName}}
                        role={{jobTitle,setJobTitle}}
                        message={{message1,message2,setMessage1,setMessage2}}
                        image={{userImage,setUserImage}}
                    />
                </div>
    
                <div className="snapboard-footer-part">
                    <p>Last updated {moment(new Date().getTime()).format('DD/MM/YYYY HH:mm')} </p>
                    <p>Powered by</p>
                    <img
                        width="60px"
                        src={snapfix_icon}
                        alt="snapfix-logo"
                        className="snapboard-sf-logo"
                    />
                </div>
                
                <div className="second-screen-checkbox">
                    <p>
                        Some companies choose to display their corporate hygiene policy or another message 
                        on a second slide which is shown in rotation on a constant loop – this is optional.
                    </p>
                    <FormControlLabel
                        onChange={() => {
                            setSecondPage(!secondPage)
                        }}
                        control={
                            <Checkbox
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                name="checked1"
                            />
                        }
                        label="I wish to include a second screen using my own full screen JPEG image"
                    />
                     {/* <Tooltip title="">
                        <ReportIcon style={{ color: '#0d7cf5' }} />
                    </Tooltip> */}
                </div>
    
                    { secondPage ? 
                        <OptionalPage
                            title={{secondTitle,setSecondTitle}}
                            logo={{optionalLogo,setOptionalLogo}}
                            image={{optionalImage,setOptionalImage}}
                        /> : null
                    }
    
                    <AdminCredentials
                        email={{userEmail,setUserEmail}}
                        pass={{password,setPassword}}
                    />

                    { !loading ?
                        <Button
                            variant="contained"
                            className="save-snapboard-button"
                            onClick={saveExternalSnapboard}
                        >
                            Save <ArrowRightIcon style={{ color: 'white' }} />
                        </Button> :
                         <CircularProgress className="loading-process" />}
            </div>
        )
    } else {
        return (
            <SnapboardLinkPage link={externalURL}/>
        )
    }
    
};

export default NewUserSnapboard;